import { Component, Input, OnInit, SimpleChanges } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { FormControl, NgForm, Validators } from '@angular/forms';
import Swal from 'sweetalert2';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { DatePipe } from '@angular/common';
import { UrlConstants } from "src/app/models/urlConstants";
import { Account, ClientData, PortfolioElement } from 'src/app/screens/user-profile/client-data';
import { RequestService } from 'src/app/services/request.service';
import { BroadcastEventListener, ISignalRConnection, SignalR, SignalRConfiguration } from 'ng2-signalr';
import { ApiService } from 'src/app/services/api.service';
import { on } from 'node:events';

enum OptionType {

  Cash = 'cash-transfer',
  Stock = 'stock-transfer',
}

interface Option {
  id: OptionType;
  label: string;
}
interface StockTransferRequest {
  FromRelationCode: string;
  ToRelationCode: string;
  Symbol: PortfolioElement;
  Qty: number;
}
interface CashTransferRequest {
  Date: String;
  FromRelationCode: string;
  IpAddress: string;
  ToRelationCode: string;
  CurrencyId: number;
  Amount: number;
  IsPost: boolean;
}
@Component({
  selector: 'app-request-transfer',
  templateUrl: './request-transfer.component.html',
  styleUrls: ['./request-transfer.component.scss']
})
export class RequestTransferComponent implements OnInit {
selectedOption: OptionType = null;
  options: Option[] = [];
  balanceAmount: any;
  purchasePowerRes: any;
  @Input() selectedAccount: Account;
  selectedFromAccount: Account;
  selectedToAccount: Account;
  newWithdraw: any = {};
  isSubmitting = false;
  newStockTransfer: StockTransferRequest = {} as StockTransferRequest;
  titleMessage: string;
  textConfirmMassage: string;
  today = new Date();
  currencyList: any[] = [];
  banksList: any[] = [];
  branches: any[] = [];
  availableWithdrawBalance: number;
  submitStatus;
  userPortfolio: ClientData;
  userAccounts: Account[];
  clientStocks: PortfolioElement[] = [];
  allCustod: any;
  newCashTransfer: CashTransferRequest = {} as CashTransferRequest;
  selectedStockTransferAcc;
  allstocks: any;
  stocksSymbolList: any;
  stocksCustodiansList: any;
  accList: any = [];
  toAccList: any;
  date = new Date();
  selectedSymbolControl = new FormControl(null, Validators.required);
  selectedSymbol: any;







  private portfolioConnection: ISignalRConnection;
  lastExecutionTime: number;
  isProfileLoading: boolean;
  noChart: boolean | null;
  companyName: string;
  purchaseStocks: number;
  chartStocks: number;
  ratedActiveBalance: number;
  Endorsement: string;
  toStockAccList: any;
  accountList: Account[];;


  constructor(
    public translate: TranslateService,
    private http: HttpClient,
    private router: Router,
    private datepipe: DatePipe,
    private requestService: RequestService,
    private apiService: ApiService,
    private signalR: SignalR,
  ) { 
    this.accList = JSON.parse(localStorage.getItem("accList")) as Account[];
    this.selectedAccount = this.accList[0].relationCode;

  }

  ngOnInit(): void {
    this.options = [
      { id: OptionType.Stock, label: this.translate.instant('stock-transfer') },
      { id: OptionType.Cash, label: this.translate.instant('cash-transfer') }
    ];
    this.requestService.fetchActiveBanks().subscribe(res => this.banksList = res);
    this.requestService.fetchCurrencies().subscribe(res => this.currencyList = res);
    this.selectedSymbolControl.valueChanges.subscribe((value) => {
      this.selectedSymbol = value; 
    });
    this.selectOption(OptionType.Cash);
    this.accountList = JSON.parse(localStorage.getItem("accList"));
    this.selectedAccount= this.accountList[0];
    this.clientSelected(this.selectedAccount);
    this.fetchUserPortfolio(this.selectedAccount);
  }
    ngOnChanges(changes: SimpleChanges): void {
      if (changes.selectedAccount && changes.selectedAccount.currentValue) {
        this.clientSelected(changes.selectedAccount.currentValue);
        this.fetchUserPortfolio(changes.selectedAccount.currentValue);
        this.fetchCustd();
      }
    }

    accountListValidation(e) {
      this.onFromAccountChange(e);
      if (this.accList) {
        let temp = this.accList.filter((c) => c.relationCode != e);
        this.toAccList = [...temp];
      }
    }
    
    stockTransferChanged(e) {
      this.newStockTransfer.Qty = e.SetteledQty;
    }
    accountStockListValidation(client) {
      this.newStockTransfer.Symbol = null;
      this.newStockTransfer.Qty = null;
      this.newStockTransfer.ToRelationCode = null;
      // this.newStockTransfer.FromRelationCode = client.relationCode;
      let selectedAccFrom = this.accList.find((item) => {
        return item.relationCode == client;
      });
      this.http
        .get(
          `${UrlConstants.backofficeUrl}/api/Client/GetClientInformation?relationCode=${client}`
        )
        .subscribe((res: ClientData) => {
          this.stocksSymbolList = res?.Portfolio?.RatedPortfolio?.Portfolio?.sort(
            (a, b) => a.SymbolNameAr.localeCompare(b.SymbolNameAr)
          );
        });
      if (this.accList) {
        let temp = this.accList.filter((x) => {
          return (
            x.SubCode == selectedAccFrom.SubCode &&
            x.relationCode != selectedAccFrom.relationCode
          );
        });
  
        this.toStockAccList = [...temp];
  
      }
    }

    availableTransferBalance(form) {
      if (form.form.get("Currency")?.value != null) {
        if (
          this.balanceAmount &&
          form.form.get("Currency")?.value["AbbreviationE"] != null
        ) {
          var x = this.balanceAmount.find(
            (item) => item.curr == form.form.get("Currency").value["AbbreviationE"]
          );
  
          if (x) return x["availablebalancefortransfer"];
          else return 0;
        }
      }
    }
    fetchCustd() {
      this.apiService.fetchAllCustd().subscribe((arg) => (this.allCustod = arg));
    }
  selectOption(optionId: OptionType) {
    this.selectedOption = optionId;
    switch (optionId) {
      case OptionType.Stock:
        this.newWithdraw.ActionType = 1;
        break;
      case OptionType.Cash:
        this.newWithdraw.ActionType = 2;
        break;
        default:
          this.newWithdraw.ActionType = 1; 
          break;

    }
  }
      clientSelected(e: Account) {
           
        // this.apiService.fetchClientAccounts(e.relationCode).subscribe((res) => {
        //   this.userAccounts = res as Account[];
        //   this.initPortfolioSignalR();
        // });
      }
      fetchUserPortfolio(selectedAcc?) {
        if (selectedAcc) this.selectedAccount = selectedAcc;
    
        if (this.selectedAccount != null && this.selectedAccount.relationCode) {
          this.requestService.fetchUserPortfolio(this.selectedAccount.relationCode)
            .subscribe((res) => {
              this.userPortfolio = res as ClientData;
              this.clientStocks = res.Portfolio.EGPPortfolio?.Portfolio as PortfolioElement[];
              
            });
        }
      }

      onFromAccountChange(relationCode: string) {
        
        const selectedAcc = this.userAccounts.find(acc => acc.relationCode === relationCode);
        if (selectedAcc) {
          this.selectedAccount = selectedAcc; 
          this.selectedFromAccount = this.selectedAccount;
          this.fetchUserPortfolio(selectedAcc); 
          this.fetchPurchasePower(relationCode)
          this.filteredUserAccounts();
        }
        else {
          this.selectedFromAccount = null; 
        }
      }
           filteredUserAccounts() {
            if (!this.selectedFromAccount) {
          return this.userAccounts; 
           }
           
            return this.userAccounts.filter(account => account.relationCode !== this.selectedFromAccount.relationCode);
           }
      
          onToAccountChange(selectedAccount: string) {
            selectedAccount = this.selectedToAccount.relationCode;
            }

         initPortfolioSignalR() {
             if (this.portfolioConnection != null) this.portfolioConnection.stop();
         
             if (this.selectedAccount.ExchangeCode != null) {
               let config: SignalRConfiguration = new SignalRConfiguration();
               config.url = UrlConstants.backofficeUrl;
               config.hubName = "ordersHub";
               config.logging = false;
         
               this.signalR.connect(config).then((res) => {
                 this.portfolioConnection = res;
         
                 this.portfolioConnection.invoke(
                   "JoinGroup",
                   this.selectedAccount.ExchangeCode
                 );
         
                 let method = new BroadcastEventListener<any>("UpdatePortfolio");
         
                 this.portfolioConnection.listen(method);
                 method.subscribe((update) => {
                   this.refetchClientInfo();
                 });
         
                 this.portfolioConnection.errors.subscribe((res) => {
                   this.initPortfolioSignalR();
                 });
               });
             }
           }
         
             refetchClientInfo() {
                    if (this.selectedAccount != null && this.selectedAccount.relationCode) {
                      const currentTime = Date.now();
                      const timeElapsed = currentTime - this.lastExecutionTime;
                
                      if (timeElapsed < 5000) {
                        return;
                      }
                
                      // Update the last execution time
                      this.lastExecutionTime = currentTime;
                
                      this.noChart = null;
                      this.isProfileLoading = true;
                
                      this.http
                        .get(
                          `${UrlConstants.backofficeUrl}/api/Client/GetClientInformation?relationCode=${this.selectedAccount.relationCode}`
                        )
                        .subscribe((res) => {
                          this.isProfileLoading = false;
                          this.userPortfolio = res as ClientData;
                
                          this.companyName = this.userPortfolio.Profile.CompanyNameAr;
                
                          this.Endorsement = `الساده شركة ${this.companyName} برجاء التكرم بفتح حد إئتمان للتداول في ذات الجلسة علي حسابي طرف شركتكم  وفي حالة التنفيذ و ظهور مديونية أتعهد أن يتم سداد كامل مديونية اليوم بالبيع أو بالإيداع و في حالة عدم التزامي بإغلاق المديونية قبل نهاية الجلسة بنصف ساعة أفوض الشركة ببيع أي أسهم موجودة بمحفظتي لسداد كامل المديونية وهذا إقرار مني بذلك`;
                
                          if (
                            this.ratedActiveBalance == 0 &&
                            this.userPortfolio.Portfolio.RatedPortfolio == null
                          )
                            this.noChart = true;
                          else if (
                            this.ratedActiveBalance > 0 &&
                            (!this.userPortfolio.Portfolio?.RatedPortfolio ||
                              this.userPortfolio.Portfolio?.RatedPortfolio?.TotalMarketValue ==
                              0)
                          ) {
                            this.purchaseStocks = 100;
                            this.chartStocks = 0;
                          } else if (
                            this.ratedActiveBalance <= 0 &&
                            this.userPortfolio.Portfolio.RatedPortfolio.TotalMarketValue > 0
                          ) {
                            this.purchaseStocks = 0;
                            this.chartStocks = 100;
                          } else if (this.userPortfolio.Portfolio.RatedPortfolio != null) {
                            this.chartStocks =
                              (this.userPortfolio.Portfolio.RatedPortfolio.TotalMarketValue /
                                (this.userPortfolio.Portfolio.RatedPortfolio.TotalMarketValue +
                                  this.ratedActiveBalance)) *
                              100;
                            this.purchaseStocks =
                              (this.ratedActiveBalance /
                                (this.userPortfolio.Portfolio.RatedPortfolio.TotalMarketValue +
                                  this.ratedActiveBalance)) *
                              100;
                          }
                        });
                    } else this.portfolioConnection.stop();
                  }
  fetchPurchasePower(relCode) {
    if (relCode != null) {
      this.apiService.fetchPurchasePower(relCode).subscribe((arg) => {
        this.purchasePowerRes = arg;

        this.balanceAmount = this.purchasePowerRes.BlockingAmount;
      });
    }



  }

  submitStockTransfer(form: NgForm) {

    
    this.isSubmitting = true;

    let request = {
      FromRelationCode: form.form.value.FromAccount,
      ToRelationCode: form.form.value.ToAccount,
      SymbolCode: this.selectedSymbol.SymbolCode,
      CustodianCode: form.form.value.CustodianCode.CustodianCode,
      Qty: form.form.value.Amount,
    };
    if (form && form.valid) {
      if (this.translate.currentLang == "ar") {
        this.titleMessage = "تأكيد تحويل اسهم";
        this.textConfirmMassage = `برجاء مراجعه البيانات التالية قبل ارسال التحويل
        من الحساب: ${form.form.value.FromAccount} الى الحساب: ${form.form.value.ToAccount}
        امين حفظ: ${form.form.value.CustodianCode.CustodianNameA}
        كمية: ${form.form.value.Amount}
        السهم: ${this.selectedSymbol.SymbolNameAr}`;
      }
      if (this.translate.currentLang == "en") {
        this.titleMessage = "Stock Transfer Confirmation";
        this.textConfirmMassage = `Please check the information before sending the request
   From Account: ${form.form.value.FromAccount} To Account: ${form.form.value.ToAccount}
   Stock: ${this.selectedSymbol.SymbolNameEn}
   Custodian: ${form.form.value.CustodianCode.CustodianNameE}
   Quantity: ${form.form.value.Amount}`;
      }



      Swal.fire({
        title: this.titleMessage,
        html: "<pre>" + this.textConfirmMassage + "</pre>",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: this.translate.instant("yes"),
        cancelButtonText: this.translate.instant("no"),
        reverseButtons: true,
      }).then((result) => {
        if (result.isConfirmed) {
          this.http
            .post(
              UrlConstants.backofficeUrl + "/api/Journal/TransferClientStocks",
              request
            )
            .subscribe((res) => {
              this.submitStatus = res;
              if (res["errors"] == null) {
                this.isSubmitting = false;
                form.resetForm();
                Swal.fire({
                  position: "center",
                  icon: "success",
                  title: this.translate.instant("succes-msg"),
                  showConfirmButton: false,
                  timer: 4500,
                });
                this.router.navigate(['/requests-analysis/requests-table']);
              } else {
                this.isSubmitting = false;
                Swal.fire({
                  position: "center",
                  icon: "error",
                  title: this.translate.instant(res["errors"][0]),
                  showConfirmButton: false,
                  timer: 4500,
                });
                this.router.navigate(['/requests-analysis/requests-table']);
              }
            });
        } else if (
          /* Read more about handling dismissals below */
          !result.isConfirmed
        ) {
          this.isSubmitting = false;
        }
      });
    }
  }

  submitCashTransfer(form: NgForm) {
    this.isSubmitting = true;
    let latest_date = this.datepipe.transform(this.date, "YYYY-MM-dd");

    this.newCashTransfer.Date = latest_date;
    this.newCashTransfer.IpAddress = "";
    this.newCashTransfer.IsPost = true;

    if (form && form.valid) {
      if (this.translate.currentLang == "ar") {
        this.titleMessage = "تأكيد تحويل نقدي";
        this.textConfirmMassage = `برجاء مراجعه البيانات التالية قبل ارسال الطلب
     من الحساب: ${form.form.value.FromAccount} الى الحساب: ${form.form.value.ToAccount}
     مبلغ: ${form.form.value.Amount} العملة: ${form.form.value.Currency.AbbreviationA}`;
      }
      if (this.translate.currentLang == "en") {
        this.titleMessage = "Cash transfer Confirmation";
        this.textConfirmMassage = `Please check the information before sending the request
      From Account: ${form.form.value.FromAccount} To Account: ${form.form.value.ToAccount}
     Amount: ${form.form.value.Amount} Currency: ${form.form.value.Currency.AbbreviationE}`;
      }
      this.newCashTransfer.CurrencyId = form.form.value.Currency.CurrencyID;
      Swal.fire({
        title: this.titleMessage,
        html: "<pre>" + this.textConfirmMassage + "<pre>",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: this.translate.instant("yes"),
        cancelButtonText: this.translate.instant("no"),
        reverseButtons: true,
      }).then((result) => {
        if (result.isConfirmed) {
          this.http
            .post(
              UrlConstants.backofficeUrl + "/api/Journal/TransferClientJournal",
              this.newCashTransfer
            )
            .subscribe(
              (res) => {
                this.isSubmitting = false;
                if (res["isValid"] == true) {
                  this.submitStatus = res;
                  form.resetForm();
                  Swal.fire({
                    position: "center",
                    icon: "success",
                    title: this.translate.instant("succes-msg"),
                    showConfirmButton: false,
                    timer: 4500,
                  }).then(() => {
                    this.router.navigate(['/requests-analysis/requests-table']);
                  });
                } else {
                  Swal.fire({
                    position: "center",
                    icon: "error",
                    title: this.translate.instant("error-msg"),
                    showConfirmButton: false,
                    timer: 4500,
                  });
                  this.router.navigate(['/requests-analysis/requests-table']);
                }
              },
              (err) => {
                Swal.fire({
                  position: "center",
                  icon: "error",
                  title: this.translate.instant("error-msg"),
                  showConfirmButton: false,
                  timer: 4500,
                });
              }
            );
        } else if (
          /* Read more about handling dismissals below */
          !result.isConfirmed
        ) {
          this.isSubmitting = false;
        }
      });
    }
  }
}